export default {"src":"/_next/static/image/public/images/ic_edit.b30a7779bea2a08aa452f1e8a1a08351.svg","height":16,"width":16};